import type { ComponentProps } from "react";

import type { E2EAgentRunCheckSummary } from "../api/admin";
import type { Status } from "../components/ui";

type SeverityCount = NonNullable<
  E2EAgentRunCheckSummary["xlm"]["severity_counts"]
>[number];

export const CHECK_SEVERITY_PRESENTATION = {
  critical: { label: "Critical", tone: "danger" },
  error: { label: "Error", tone: "danger" },
  warning: { label: "Warning", tone: "warning" },
  major: { label: "Major", tone: "danger" },
  minor: { label: "Minor", tone: "warning" },
  nit: { label: "Nit", tone: "neutral" },
  unclassified: { label: "Unclassified", tone: "neutral" },
} satisfies Record<
  SeverityCount["severity"],
  { label: string; tone: NonNullable<ComponentProps<typeof Status>["tone"]> }
>;
